import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.proxyHandleButtonDialog = this.handleButtonDialog.bind(this);
    document.addEventListener("trix-toolbar-dialog-show", this.proxyHandleButtonDialog);
  }

  disconnect() {
    document.removeEventListener("trix-toolbar-dialog-show", this.proxyHandleButtonDialog);
  }

  handleButtonDialog(event) {
    if (event.dialogName !== "button") { return; }

    if (this.attributeIsActive()) {
      this.inputElement.value  = this.getBlock['htmlAttributes']['href'];
      this.buttonElement.value = "Update";
    } else {
      this.inputElement.value = "";
      this.buttonElement.value = "Insert";
    }
    this.inputElement.focus();
  }

  updateButtonHTML() {
    if (this.attributeIsActive() && this.inputElement.value) {
      let block = this.getBlock;
      if (!block) { return; }

      let newBlock = Trix.Block.fromJSON(JSON.parse(JSON.stringify(block)));
      newBlock['htmlAttributes']['href'] = this.inputElement.value;
      this.replaceBlock(block, newBlock);

      // https://www.kindleman.com.au/blog/advanced-actiontext-modifications-for-cms-use/
      this.editor.selectionManager.unlock();
      this.dialog.classList.remove("trix-active");
      delete this.dialog.dataset.trixActive;
      this.inputElement.setAttribute("disabled", "disabled");
    }
    else if (this.inputElement.value) {
      // https://github.com/basecamp/trix/issues/256
      let range = this.editor.getSelectedRange();
      let selectedText = this.editor.getDocument().getDocumentAtRange(range).toString().trim();
      if (!selectedText) {
        selectedText = this.inputElement.value;
      }

      // Insert the button
      let buttonHTML = `<button href="${this.inputElement.value}">${selectedText}</button>`;
      this.editor.insertHTML(buttonHTML);

      // https://github.com/basecamp/trix/issues/591
      this.editor.selectionManager.unlock();
      this.inputElement.value = "";
    }
    else {
      this.inputElement.setAttribute("data-trix-validate", "");
      this.inputElement.classList.add("trix-validate");
      this.inputElement.focus();
    }
  }

  get editor() {
    return this.element.querySelector("trix-editor").editor;
  }

  get dialog() {
    return this.element.querySelector("[data-trix-dialog=button]");
  }

  get inputElement() {
    return this.dialog.querySelector("input[name=href]");
  }

  get buttonElement() {
    return this.dialog.querySelector("input[type=button]");
  }

  get getBlock() {
    return this.editor.composition.getBlock();
  }

  replaceBlock(block, newBlock) {
    this.editor.composition.setDocument(this.editor.composition.document.replaceBlock(block, newBlock));
  }

  attributeIsActive() {
    return this.editor.attributeIsActive("button");
  }
}
